import React, { useEffect, useState } from 'react';
import TrashIcon from 'images/Trash-2-outline.svg';
import AddIcon from 'images/Plus-outline.svg';
import RemoveIcon from 'images/Minus-outline.svg';

const CatalogProductQuantity = ({ quantity, onChangeQuantity, maxQuantity = null }) => {
  const [currentQuantity, setCurrentQuantity] = useState(quantity.toString());
  const [showStockWarning, setShowStockWarning] = useState(false);

  const hasMax = maxQuantity !== null && maxQuantity !== undefined && Number.isFinite(Number(maxQuantity));
  const max = hasMax ? Number(maxQuantity) : null;
  const isOutOfStock = max !== null && max <= 0;
  const isAtMax = max !== null && quantity >= max;

  useEffect(() => {
    if (quantity.toString() !== currentQuantity) {
      setCurrentQuantity(quantity.toString());
    }
  }, [quantity]);

  useEffect(() => {
    if (max === null || quantity <= max) return;

    onChangeQuantity(max);
    setCurrentQuantity(String(max));
  }, [max, quantity]);

  const onPressMinus = () => {
    setShowStockWarning(false);
    onChangeQuantity(quantity - 1);
  };

  const onPressPlus = () => {
    if (isAtMax) {
      setShowStockWarning(true);
      return;
    }

    setShowStockWarning(false);
    onChangeQuantity(quantity + 1);
  };

  const onChangeQuantityInput = ({ target }) => {
    if (target.value === '') {
      setCurrentQuantity('');
      return;
    }

    if (!/^[0-9]*$/.test(target.value)) return;

    const parsedQuantity = parseInt(target.value, 10);

    if (max !== null && parsedQuantity > max) {
      setCurrentQuantity(String(max));
      onChangeQuantity(max);
      setShowStockWarning(true);
      return;
    }

    setShowStockWarning(false);
    onChangeQuantity(parsedQuantity);
  };

  const onBlur = ({ target }) => {
    if (target.value === '') {
      onChangeQuantity(0);
    }
  };

  return (
    <div className="catalog-product-quantity-wrapper">
      <div className="catalog-product-quantity d-flex me-md-1 me-2">
        {quantity > 0 && (
          <button type="button" className="btn pe-0" onClick={onPressMinus}>
            <img src={quantity > 1 ? RemoveIcon : TrashIcon} alt="" />
          </button>
        )}
        <input
          type="text"
          value={currentQuantity}
          onChange={onChangeQuantityInput}
          onBlur={onBlur}
          className="bg-transparent border-0 text-center"
        />
        <button
          type="button"
          className={`btn ps-0 ${isAtMax ? 'opacity-50' : ''}`}
          onClick={onPressPlus}
          aria-disabled={isAtMax}
        >
          <img src={AddIcon} alt="" />
        </button>
      </div>
      {!isOutOfStock && showStockWarning && max !== null && (
        <small className="text-danger catalog-product-quantity-error">
          Stock disponible {max} u.
        </small>
      )}
    </div>
  );
};

export default CatalogProductQuantity;
